module.exports = __webpack_public_path__ + "static/interstate-bold-condensed-4ff16da84ef0cb9be3425d1228950556.woff2";